const CONTEXT_25_UTM_PARAMS_BASE = {
  utmSource: 'my.livechatinc.com',
  utmCampaign: 'context25',
  utmContent: 'hubpromo',
} as const;

const CONTEXT_25_UTM_PARAMS = {
  ...CONTEXT_25_UTM_PARAMS_BASE,
  utmMedium: 'inappbanner',
} as const;

export const CONTEXT25_COLORS = {
  textAndIcons: '#F8FFED',
  buttonText: '#0F1D18',
} as const;

const CONTEXT_25_BASE_URL = 'https://www.text.com/context25';

export const CONTEXT_25_CAMPAIGN = {
  baseUrl: CONTEXT_25_BASE_URL,
  utmParams: CONTEXT_25_UTM_PARAMS,
} as const;
